/**
 * SearchAndFilters - Interface de recherche et filtres pour participants
 */
import React, { memo } from 'react';

const SearchAndFilters = memo(({
  search,
  teamFilter,
  teams = [],
  users = [],
  userAvailability = {},
  loading = false,
  canCreateInterim = false,
  paginatedUsers = { users: [], availableCount: 0 },
  onSearchChange,
  onTeamFilterChange,
  onAddAvailable,
  onRemovePage,
  onAddTeamMembers,
  onCreateInterim
}) => {
  return (
    <div className="pi-search-filters">
      <div className="pi-search-grid">
        <input
          type="text"
          placeholder="Rechercher par nom, groupe, rôle..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pi-search-input"
        />

        <select
          value={teamFilter}
          onChange={(e) => onTeamFilterChange(e.target.value)}
          className="pi-search-select"
        >
          <option value="">Tous les groupes</option>
          {teams.map(group => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>

        <div className="pi-quick-actions">
          <button
            type="button"
            onClick={onAddAvailable}
            className="pi-quick-btn pi-quick-btn--success"
            disabled={loading}
            title="Ajouter tous les disponibles de la page"
          >
            Dispo
          </button>
          <button
            type="button"
            onClick={onRemovePage}
            className="pi-quick-btn pi-quick-btn--danger"
            title="Retirer tous les participants de la page"
          >
            Page
          </button>
        </div>
      </div>

      <div className="pi-team-buttons">
        <span className="pi-team-buttons__label">Ajouter groupe complet :</span>
        {teams.slice(0, 4).map(group => {
          const availableMembers = users.filter(u => {
            if (!u.group_ids?.includes(group.id) && u.group_id !== group.id) return false;
            const status = userAvailability[u.id]?.status;
            // Exclure hr_unavailable des membres disponibles
            return status === 'available' || !status;
          });

          return (
            <button
              key={group.id}
              type="button"
              onClick={() => onAddTeamMembers(group.id)}
              disabled={loading || availableMembers.length === 0}
              className="pi-team-btn"
            >
              + {group.name} ({availableMembers.length})
            </button>
          );
        })}

        {/* Bouton création rapide d'intérimaire */}
        {canCreateInterim && onCreateInterim && (
          <button
            type="button"
            onClick={onCreateInterim}
            className="pi-team-btn"
            style={{
              background: 'linear-gradient(135deg, #6f42c1, #9c27b0)',
              color: 'white',
              border: 'none',
              marginLeft: '8px'
            }}
            title="Créer un nouvel intérimaire et l'ajouter aux participants"
          >
            + Intérimaire
          </button>
        )}
      </div>
    </div>
  );
});

SearchAndFilters.displayName = 'SearchAndFilters';

export default SearchAndFilters;
